import api from './config';

export const bonificacionesAPI = {
  getAll: (companyId) =>
    api.get('/bonificaciones', { params: { companyId } }).then(r => r.data),

  calcular: (data) =>
    api.post('/bonificaciones/calcular', data).then(r => r.data),

  getById: (id) =>
    api.get(`/bonificaciones/${id}`).then(r => r.data),

  getDetalle: (id) =>
    api.get(`/bonificaciones/${id}/detalle`).then(r => r.data),

  updateDetalle: (id, detalleId, data) =>
    api.put(`/bonificaciones/${id}/detalle/${detalleId}`, data).then(r => r.data),

  recalcularDesempeno: (id) =>
    api.post(`/bonificaciones/${id}/recalcular-desempeno`, {}).then(r => r.data),

  calcularISR: (id) =>
    api.post(`/bonificaciones/${id}/calcular-isr`, {}).then(r => r.data),

  aprobar: (id) =>
    api.post(`/bonificaciones/${id}/aprobar`, {}).then(r => r.data),

  pagar: (id) =>
    api.post(`/bonificaciones/${id}/pagar`, {}).then(r => r.data),

  eliminar: (id) =>
    api.delete(`/bonificaciones/${id}`).then(r => r.data),

  revertir: (id) =>
    api.post(`/bonificaciones/${id}/revertir`, {}).then(r => r.data),

  downloadPayslip: (id, detalleId) =>
    api.get(`/bonificaciones/${id}/detalle/${detalleId}/payslip`, { responseType: 'blob' }).then(r => r.data),
};
